import { useEffect, useRef } from 'react';

export const useElementWidth = <T extends HTMLElement = HTMLDivElement>(
  onWidthChange?: (width: number) => void
) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !onWidthChange) return;

    const observer = new ResizeObserver(([entry]) => {
      if (entry) {
        onWidthChange(entry.contentRect.width);
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [onWidthChange]);

  return ref;
};
